export const capitalize = str => {

  // typeof undefined === 'undefined';

  if(typeof str === 'string'){
    return str.toUpperCase()
  } else if (typeof str !== 'string') {
    return "[NO String was entered]"
  }

}

export const removePathSlashes = str => {

  if(typeof str === 'string'){
    if (str.length > 1) {
      console.log("format path output: ", str.slice(1, -1))
      return str.slice(1, -1)
    }

    if(str === '/'){
      return 'home'
    }
  }

}


// WEBPACK FOOTER //
// ./src/utils/helpers.js